export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api';
export const ADMIN_TITLE = '灵彩AI · 管理后台';
export const APP_ENV = process.env.VUE_APP_ENV || 'local';
